export default "__VITE_PUBLIC_ASSET__d268c29e__"